import { jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { FocusRing } from "../../../library/react-aria/FocusRing.js";
const skipLink = "_skipLink_1ryvl_1";
const skipLink__text = "_skipLink__text_1ryvl_27";
const styles = {
  skipLink,
  skipLink__text
};
const SkipLink = ({ children, targetId, className, ...props }) => {
  return /* @__PURE__ */ jsx(FocusRing, { children: /* @__PURE__ */ jsx(
    "a",
    {
      href: `#${targetId.replace("#", "")}`,
      className: clsx(styles.skipLink, className),
      ...props,
      children: /* @__PURE__ */ jsx(Text, { component: "span", className: styles.skipLink__text, children })
    }
  ) });
};
export {
  SkipLink
};
